export function SkeletonNote() {
  return (
    <div className="mt-4 flex w-full flex-col px-4">
      <div className="bg-primary-300/60 animate-pulse rounded-md p-3" />
      <div className="bg-primary-100/60 mt-2 h-20 animate-pulse rounded-md" />
      <div className="bg-primary-100/60 mt-2 h-28 animate-pulse rounded-md" />
    </div>
  )
}
